var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2864 13.1315C18.2864 16.1133 16.5293 17.8704 13.5475 17.8704H7.05904C4.06963 17.8704 2.3125 16.1133 2.3125 13.1315V6.63542C2.3125 3.65362 3.40786 1.89648 6.38966 1.89648H8.05551C8.65407 1.89648 9.2177 2.1783 9.57684 2.65715L10.3375 3.66883C10.6974 4.14674 11.2605 4.4283 11.8588 4.42949H14.2169C17.2063 4.42949 18.3093 5.95082 18.3093 8.99347L18.2864 13.1315Z",
    stroke: "#37B97A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.29688 12.0737H14.2914",
    stroke: "#37B97A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveFolder);
export default __webpack_public_path__ + "static/media/activeFolder.1b5a6dff6d424108ff7df407494114dc.svg";
export { ForwardRef as ReactComponent };